import { Component } from '@angular/core';

@Component({
  selector: 'app-mid-fleet',
  templateUrl: './mid-fleet.component.html',
  styleUrl: './mid-fleet.component.css'
})
export class MidFleetComponent {

}
